<script>
import {
  pageTitleMixin,
  prefetchDataMixin,
} from '@ubic/vue-mixins';
import { permissions } from '@/constants';
import ErrorAccessDenied from '@/components/ErrorAccessDenied';
import FormError from '@/components/FormError';
import LogFields from './components/LogFields';
import service from './service';

export default {
  pageTitle: 'Детали записи лога',
  async prefetchData () {
    if (!this.hasPermissions) {
      return;
    }

    this.isFetching = true;

    [this.workerOptions, this.projectOptions] = await Promise.all([
      service.workerOptions(),
      service.projectOptions(),
    ]);

    this.isFetching = false;
  },
  mixins: [
    pageTitleMixin,
    prefetchDataMixin,
  ],
  data () {
    return {
      isFetching: false,
      isSaving: false,
      error: '',
      workerOptions: [],
      projectOptions: [],

      fields: {
        worker: '',
        project: '',
        date: '',
        hours: '',
        task: '',
      },
    };
  },
  computed: {
    hasPermissions () {
      return (
        this.$store
          .getters['auth/checkPermission'](permissions.LOG_WRITE)
        && this.$store
          .getters['auth/checkPermission'](permissions.WORKER_READ)
        && this.$store
          .getters['auth/checkPermission'](permissions.PROJECT_READ)
      );
    },
  },
  methods: {
    handleFieldsChange (fields) {
      this.fields = fields;
    },
    async handleSubmit (e) {
      e.preventDefault();

      if (this.isSaving) {
        return;
      }

      this.isSaving = true;
      this.error = '';

      try {
        await service.create(this.fields);

        this.emitDataUpdate();
        this.handleClose();
      } catch (error) {
        this.error = 'Ошибка при сохранении записи';
        this.isSaving = false;
      }
    },

    handleClose () {
      this.$router.replace({
        ...this.$route,
        path: '/logs',
      });
      this.$emit('close');
    },
    emitDataUpdate () {
      this.$emit('dataupdate');
    },
  },
  render () {
    if (!this.hasPermissions) {
      return (
        <u-modal onClose={this.handleClose}>
          <ErrorAccessDenied />
        </u-modal>
      );
    }

    const { isSaving, error } = this;

    return (
      <u-modal onClose={this.handleClose}>
        <u-title
          slot="header"
          level="2"
        >
          Новая запись
        </u-title>

        {this.isFetching ? (
          <u-spinner />
        ) : (
          <form
            action="#"
            method="post"
            onSubmit={this.handleSubmit}
          >
            <LogFields
              projectOptions={this.projectOptions}
              workerOptions={this.workerOptions}
              disabled={isSaving}
              canReadTask
              onChange={this.handleFieldsChange}
            />

            {Boolean(error) && (
              <FormError>
                {error}
              </FormError>
            )}

            <footer clsas="form-footer">
              <u-btn
                type="submit"
                size="wide"
              >
                {isSaving
                  ? <u-spinner inline />
                  : 'Создать'}
              </u-btn>
            </footer>
          </form>
        )}
      </u-modal>
    );
  },
};
</script>
